// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-detail-container[data-v-099b9f1f] {\n  font-size: 14px;\n}\n.setting-detail-label[data-v-099b9f1f] {\n  display: inline-block;\n  color: #5E6E82;\n  min-width: 220px;\n  font-weight: 500;\n}\n.setting-item-value[data-v-099b9f1f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.tips[data-v-099b9f1f] {\n  color: #364250;\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
